






import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  components: {
  }
})
export default class IdrMaiZhuanjia extends Vue {
  @Prop()
  private current: any;
  @Prop()
  private faceId: any;
}
